import { Type } from 'class-transformer';
import { Model } from './model';
import { Channel } from './channel';

export enum AlertFrequency {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export class AlertConfig extends Model {
  id: string;

  channel_id: string;

  @Type(() => Channel)
  channel: Channel;

  frequency: AlertFrequency;

  is_enabled: boolean;

  name: string;

  to_number: string;

  get integration_id(): string {
    return this.channel.linked_integration.id;
  }
}
